/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  FETCH_PRIMARY_RIDP,
  POST_SECONDARY_RIDP,
  FETCH_FARS_RESPONSE,
  POST_COMPLETE_FA_RS,
  POST_RBA_RIDP,
  POST_GET_RECORD_RESPONSE,
} from './actionTypes';

/**
 * Updates the details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchPrimaryRIDPReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_PRIMARY_RIDP);

/**
 * Updates the indicator of creation of details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchPrimaryRIDPReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_PRIMARY_RIDP);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchPrimaryRIDPErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_PRIMARY_RIDP);

/**
 * Updates the details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postSecondaryRIDPReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_SECONDARY_RIDP);

/**
 * Updates the indicator of creation of details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostSecondaryRIDPReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_SECONDARY_RIDP);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postSecondaryRIDPErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_SECONDARY_RIDP);

/**
 * Updates the details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchFarsResponseReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_FARS_RESPONSE);

/**
 * Updates the indicator of creation of details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchFarsResponseReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_FARS_RESPONSE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchFarsResponseErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_FARS_RESPONSE);

/**
 * Updates the details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postCompleteFARsReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_COMPLETE_FA_RS);

/**
 * Updates the indicator of creation of details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostCompleteFARsReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_COMPLETE_FA_RS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postCompleteFARsErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_COMPLETE_FA_RS);

/**
 * Updates the details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postRbaRIDPReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_RBA_RIDP);

/**
 * Updates the indicator of creation of details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostRbaRIDPReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_RBA_RIDP);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postRbaRIDPErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_RBA_RIDP);

/**
 * Updates the details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postGetRecordResponseReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_GET_RECORD_RESPONSE);

/**
 * Updates the indicator of creation of details in the 'RIDP' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostGetRecordResponseReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_GET_RECORD_RESPONSE);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postGetRecordResponseErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_GET_RECORD_RESPONSE);

const reducers = combineReducers({
  fetchPrimaryRIDP: fetchPrimaryRIDPReducer,

  isFetchingFetchPrimaryRIDP: isFetchingFetchPrimaryRIDPReducer,
  fetchPrimaryRIDPError: fetchPrimaryRIDPErrorReducer,

  postSecondaryRIDP: postSecondaryRIDPReducer,

  isFetchingPostSecondaryRIDP: isFetchingPostSecondaryRIDPReducer,
  postSecondaryRIDPError: postSecondaryRIDPErrorReducer,

  fetchFarsResponse: fetchFarsResponseReducer,

  isFetchingFetchFarsResponse: isFetchingFetchFarsResponseReducer,
  fetchFarsResponseError: fetchFarsResponseErrorReducer,

  postCompleteFARs: postCompleteFARsReducer,

  isFetchingPostCompleteFARs: isFetchingPostCompleteFARsReducer,
  postCompleteFARsError: postCompleteFARsErrorReducer,

  postRbaRIDP: postRbaRIDPReducer,

  isFetchingPostRbaRIDP: isFetchingPostRbaRIDPReducer,
  postRbaRIDPError: postRbaRIDPErrorReducer,

  postGetRecordResponse: postGetRecordResponseReducer,

  isFetchingPostGetRecordResponse: isFetchingPostGetRecordResponseReducer,
  postGetRecordResponseError: postGetRecordResponseErrorReducer,
});

export default { reducers };
